<template>
    <rkm-content>
        <rkm-content-header :title="$route.meta.title" />

        <rkm-content-body>
            <rkm-container
                v-if="authorize('cadastro-cidadao-show')"
                no-card
            >
                <rkm-overlay :show="loading">
                    <rkm-card-group deck>
                        <rkm-card no-body>
                            <rkm-card-body
                                body-bg-color="success"
                                body-text-color="white"
                                class="rkm-card-body"
                            >
                                <rkm-row vertical-align="center">
                                    <rkm-col cols="8">
                                        <strong>{{ model.total_cadastros }}</strong>

                                        <p>
                                            cidadão(s) cadastrados no sistema
                                        </p>
                                    </rkm-col>

                                    <rkm-col class="flex-grow-1 text-right">
                                        <rkm-icon
                                            :style="{ color: 'white' }"
                                            icon="users"
                                            size="4x"
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </rkm-card-body>

                            <rkm-card-footer footer-bg-color="success">
                                <rkm-link
                                    @click="$refs.ModalCidadaoCadastrosList.open()"
                                    class="rkm-link"
                                >
                                    Ver mais <rkm-icon icon="arrow-right" />
                                </rkm-link>
                            </rkm-card-footer>
                        </rkm-card>

                        <rkm-card no-body>
                            <rkm-card-body
                                body-bg-color="info"
                                body-text-color="white"
                                class="rkm-card-body"
                            >
                                <rkm-row vertical-align="center">
                                    <rkm-col cols="8">
                                        <strong>{{ model.total_cadastros_ultimos_sete_dias }}</strong>
                                        
                                        <p>
                                            cidadão(s) cadastrados nos últimos 7 dias.
                                        </p>
                                    </rkm-col>

                                    <rkm-col class="flex-grow-1 text-right">
                                        <rkm-icon
                                            :style="{ color: 'white' }"
                                            icon="calendar-check"
                                            size="4x"
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </rkm-card-body>

                            <rkm-card-footer footer-bg-color="info">
                                <rkm-link
                                    @click="$refs.ModalCidadaoUltimosCadastrosList.open()"
                                    class="rkm-link"
                                >
                                    Ver mais <rkm-icon icon="arrow-right" />
                                </rkm-link>
                            </rkm-card-footer>
                        </rkm-card>

                        <rkm-card no-body>
                            <rkm-card-body
                                body-bg-color="warning"
                                body-text-color="white"
                                class="rkm-card-body"
                            >
                                <rkm-row vertical-align="center">
                                    <rkm-col cols="8">
                                        <strong>{{ model.total_cadastros_desatualizados }}</strong>
                                        
                                        <p>
                                            cidadão(s) com cadastro desatualizado
                                        </p>
                                    </rkm-col>

                                    <rkm-col class="flex-grow-1 text-right">
                                        <rkm-icon
                                            :style="{ color: 'white' }"
                                            icon="exclamation"
                                            size="4x"
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </rkm-card-body>

                            <rkm-card-footer footer-bg-color="warning">
                                <rkm-link
                                    @click="$refs.ModalCidadaoDesatualizadosList.open()"
                                    class="rkm-link"
                                >
                                    Ver mais <rkm-icon icon="arrow-right" />
                                </rkm-link>
                            </rkm-card-footer>
                        </rkm-card>
                    </rkm-card-group>
                </rkm-overlay>
            </rkm-container>

            <ModalCidadaoDesatualizadosList ref="ModalCidadaoDesatualizadosList" />
            <ModalCidadaoCadastrosList ref="ModalCidadaoCadastrosList" />
            <ModalCidadaoUltimosCadastrosList ref="ModalCidadaoUltimosCadastrosList" />
        </rkm-content-body>
    </rkm-content>
</template>

<script>
// Components.
import ModalCidadaoCadastrosList from '@/components/dashboard/components/cidadao/components/cadastros/Modal'
import ModalCidadaoDesatualizadosList from '@/components/dashboard/components/cidadao/components/desatualizados/Modal'
import ModalCidadaoUltimosCadastrosList from '@/components/dashboard/components/cidadao/components/ultimos-cadastros/Modal'

// Mixins.
import {authorization, error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {
        ModalCidadaoCadastrosList,
        ModalCidadaoDesatualizadosList,
        ModalCidadaoUltimosCadastrosList,
    },
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('dashboard')
        },
    },
    data: () => ({
        model: {
            total_cadastros: 0,
            total_cadastros_ultimos_sete_dias: 0,
            total_cadastros_desatualizados: 0,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading('dashboard')

            const query = {dashboard: true}

            this.repositories.cadastro.cidadao.index(query)
                .then(({ data }) => {
                    this.model.total_cadastros = data.total_cadastros
                    this.model.total_cadastros_ultimos_sete_dias = data.total_cadastros_ultimos_sete_dias
                    this.model.total_cadastros_desatualizados = data.total_cadastros_desatualizados
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading('dashboard'))
        },
    },
    mixins: [authorization, error],
    mounted() {
        if (this.authorize('cadastro-cidadao-show')) {
            this.load()
        }
    },
}
</script>

<style scoped>
.rkm-card-body {
    padding: 15px;
}
.rkm-card-body p {
    margin: 0px;
}
.rkm-card-body strong {
    display: block;
    font-size: 60px;
}
.rkm-link {
    color: white;
}
</style>